import React, { useEffect } from 'react';
import { useLocation, matchRoutes } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import _ from '@lodash';
import * as Actions from 'app/store/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FuseLayouts from '@fuse/layouts/FuseLayouts';
import { defaults as Chartjs2Defaults } from 'react-chartjs-2';
import routes from 'app/fuse-configs/routesConfig';
import { generateSettings } from '@/app/store/reducers/fuse/settings.reducer';

const styles = (theme) => ({
	root: {
		backgroundColor: theme.palette.background.default,
		color: theme.palette.text.primary,
		'& code:not([class*="language-"])': {
			color: theme.palette.secondary.dark,
			backgroundColor: theme.palette.secondary.light,
			padding: '2px 3px',
			borderRadius: 2,
			lineHeight: 1.7,
		},
		'& table.simple tbody tr td': {
			borderColor: theme.palette.divider,
		},
		'& table.simple thead tr th': {
			borderColor: theme.palette.divider,
		},
		'& a:not([role=button])': {
			color: theme.palette.secondary.main,
			textDecoration: 'none',
			'&:hover': {
				textDecoration: 'underline',
			},
		},
	},
});

const FuseLayout = ({ settings, classes, defaultSettings, setSettings, resetSettings, children, ...restProps }) => {
	const location = useLocation();
	const Layout = FuseLayouts[settings.layout.style];

	// Match current route
	const pathname = location.pathname;
	const matched = matchRoutes(routes, pathname)?.[0];

	useEffect(() => {
		if (matched && matched.route.settings) {
			const routeSettings = matched.route.settings;
			const newSettings = generateSettings(defaultSettings, routeSettings);

			if (!_.isEqual(settings, newSettings)) {
				setSettings(newSettings);
			}
		} else if (!_.isEqual(settings, defaultSettings)) {
			resetSettings();
		}

		// Animation settings
		if (!settings.animations) {
			document.body.classList.add('no-animate');
			Chartjs2Defaults.global.animation = true;
		} else {
			document.body.classList.remove('no-animate');
			Chartjs2Defaults.global.animation = false;
		}
	}, [pathname, matched, settings, defaultSettings, setSettings, resetSettings]);

	return (
		<Layout classes={{ root: classes.root }} {...restProps}>
			{children}
		</Layout>
	);
};

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			setSettings: Actions.setSettings,
			resetSettings: Actions.resetSettings,
		},
		dispatch
	);
}

function mapStateToProps({ fuse }) {
	return {
		defaultSettings: fuse.settings.defaults,
		settings: fuse.settings.current,
	};
}

export default withStyles(styles, { withTheme: true })(
	connect(mapStateToProps, mapDispatchToProps)(React.memo(FuseLayout))
);
